"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var formatAndDropDecimal_1 = __importDefault(require("./formatAndDropDecimal"));
var TileDataContext_1 = require("./TileDataContext");
var useGetItBy_1 = __importDefault(require("../hooks/useGetItBy"));
var useStatusHooks_1 = require("../hooks/useStatusHooks");
var formatDateAndMonth_1 = __importDefault(require("../utils/formatDateAndMonth"));
var StatusIcon = function () { return (react_1.default.createElement("svg", { width: "8", height: "9", viewBox: "0 0 8 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "mr-4" },
    react_1.default.createElement("rect", { y: "0.187683", width: "8", height: "8", rx: "4", fill: "#2F9E44" }))); };
function ShippingAndGetItBy() {
    var _a = (0, TileDataContext_1.useTileDataContext)(), _b = _a.tileData, shippingCost = _b.transportCost, isOnDemand = _b.isOnDemand, shouldHideShipping = _a.shouldHideShipping, dateAvailable = _a.soonestAvailabilityInfo.utcSoonestDateTimeIso;
    var _c = (0, useStatusHooks_1.useGetPurchaseStatus)(), isLocked = _c.isLocked, isOnHold = _c.isOnHold;
    var getItBy = (0, useGetItBy_1.default)().getItBy;
    var hideGetItBy = Boolean(!getItBy || isOnDemand || isLocked || isOnHold);
    var costText = shippingCost > 0 ? "$".concat((0, formatAndDropDecimal_1.default)(shippingCost)) : '';
    var divider = ' • ';
    var shippingText = shippingCost ? "Shipping: " : 'Free Shipping';
    var shouldBold = getItBy === 'Today' || getItBy === 'Tomorrow';
    return (react_1.default.createElement("section", { className: "relative box-border grid grid-flow-row grid-rows-[min-content,max-content]" }, hideGetItBy && shouldHideShipping ? null : (react_1.default.createElement("div", { className: "flex items-center border-t border-grey-2 pt-8 t-body-xs" },
        react_1.default.createElement("div", { "data-qa": "shipping-cost", className: (0, classnames_1.default)('mr-4 flex items-center gap-4 text-blue-6', {
                hidden: shouldHideShipping
            }) },
            !shouldHideShipping && !shippingCost && react_1.default.createElement(StatusIcon, null),
            shippingText,
            costText && react_1.default.createElement("span", { className: "font-normal" }, costText),
            hideGetItBy ? null : divider),
        dateAvailable && (react_1.default.createElement("div", { "data-qa": "get-it-by", className: (0, classnames_1.default)({
                invisible: hideGetItBy
            }, { 'font-bold': shouldBold }) }, "Get it ".concat(shouldBold ? getItBy : "by ".concat((0, formatDateAndMonth_1.default)(dateAvailable)))))))));
}
exports.default = ShippingAndGetItBy;
//# sourceMappingURL=ShippingAndGetItBy.js.map